import React, { useMemo } from 'react';
import { buildInstabookVideoIframeSrc } from 'utils/instabookVideo';

export type InstabookVideoIframeProps = {
  url: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
};

const InstabookVideoIframe: React.FC<InstabookVideoIframeProps> = ({
  url,
  width = 260,
  height = 215,
  className,
  style,
  title = 'Auto-book Explainer',
}) => {
  const src = useMemo(() => buildInstabookVideoIframeSrc(url), [url]);

  if (!src) return null;

  return (
    <iframe
      width={width}
      height={height}
      src={src}
      title={title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      className={className}
      style={{ border: 0, borderRadius: 8, ...style }}
    />
  );
};

export default InstabookVideoIframe;
